const tabbedContent = (): void => {
  const classes = {
    tabButtonActive: 'tab__button--active',
    tabContentActive: 'tab__content--active',
  };

  const selectors = {
    tabbedContent: '[data-tabbed-content]',
    tabbedContentContainer: '[data-tabbed-content-container]',
    tabButton: '[data-tab]',
    tabButtonID: 'data-tab',
    tabContent: '[data-content]',
    tabOpenOnLoad: 'open-on-load',
  };

  const tabedContentSections = document.querySelectorAll(
    selectors.tabbedContent
  );

  tabedContentSections.forEach((section) => {
    const tabButtons = section.querySelectorAll(selectors.tabButton);
    const tabContentsContainer = section.querySelector<HTMLElement>(
      selectors.tabbedContentContainer
    );
    const tabContents = section.querySelectorAll(selectors.tabContent);

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const buttonID = button.getAttribute(selectors.tabButtonID);
        const content = section.querySelector(
          '[data-content="' + buttonID + '"]'
        );

        tabButtons.forEach((tab) => {
          tab.classList.remove(classes.tabButtonActive);
        });

        tabContents.forEach((content) => {
          content.classList.remove(classes.tabContentActive);
        });

        button.classList.add(classes.tabButtonActive);

        if (content) {
          const contentHeight = content.scrollHeight;
          tabContentsContainer.style.setProperty(
            'height',
            contentHeight + 'px'
          );
          setTimeout(() => {
            content.classList.add(classes.tabContentActive);
          }, 300);
        }
      });
    });

    tabContents.forEach((content) => {
      if (content.hasAttribute(selectors.tabOpenOnLoad)) {
        const contentHeight = content.scrollHeight;
        tabContentsContainer.style.setProperty('height', contentHeight + 'px');
      }
    });

    window.addEventListener('resize', () => {
      const activeTabContent = section.querySelector(
        '.' + classes.tabContentActive
      );
      const contentHeight = activeTabContent.scrollHeight;
      tabContentsContainer.style.setProperty('height', contentHeight + 'px');
    });
  });
};

export default tabbedContent;
